import { API_URL } from "../config";

export const FETCH_FOOTER_DATA_REQUEST = 'FETCH_FOOTER_DATA_REQUEST';
export const FETCH_FOOTER_DATA_SUCCESS = 'FETCH_FOOTER_DATA_SUCCESS';
export const FETCH_FOOTER_DATA_FAILURE = 'FETCH_FOOTER_DATA_FAILURE';

export const fetchFooterData = () => async (dispatch, getState) => {
  const { footer } = getState();
  if (footer.fetched) {
    return;
  }

  dispatch({ type: FETCH_FOOTER_DATA_REQUEST });

  try {
    const response = await fetch(API_URL + 'content/footer');
    const data = await response.json();
    dispatch({ type: FETCH_FOOTER_DATA_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_FOOTER_DATA_FAILURE, payload: error });
  }
};
